/* eslint-disable import/prefer-default-export */
import { UsStateCaProvince } from "__generated__/gql/graphql";
import { getNullableEnumSchema } from "utils/schemas/utils";
import * as yup from "yup";

export const line1 = yup.string().label("Line 1").nullable().trim();

export const line2 = yup.string().label("Line 2").nullable().trim();

export const city = yup.string().label("City").nullable().trim();

export const state =
  getNullableEnumSchema<UsStateCaProvince>(UsStateCaProvince).label("State");

export const zip = yup
  .string()
  .label("ZIP Code")
  .nullable()
  .trim()
  .matches(/^\d{5}$/, {
    excludeEmptyString: true,
    message: "Must be a 5-digit US ZIP code.",
  });
